import {initialiseSvelteComponent} from "./helpers/initialiseSvelteComponent";
import LoginApp from "./components/LoginApp/LoginApp.svelte";
import {removeAllNonPortalCookies} from './helpers/removeAllNonPortalCookies';

require('./bootstrap');

removeAllNonPortalCookies();

/**
 * Get the translations element
 * @type {HTMLElement}
 */
const translationsElement = document.getElementById('svelte-translations-js');
const customTheme = document.getElementById('svelte-login-custom-theme') ?? '{}';
const loginErrors = document.getElementById('svelte-login-errors')?.innerText ?? '{}';
const ssoEnabledMicrosoft = document.getElementById('svelte-enable-sso-microsoft')?.innerText === 'true' ?? false;
const ssoEnabledGoogle = document.getElementById('svelte-enable-sso-google')?.innerText === 'true' ?? false;

/**
 * Initialise all the components if they are found in the dom
 */
initialiseSvelteComponent('login-app-component-js', LoginApp, {
    translationStrings: JSON.parse(translationsElement.innerText) ?? {},
    themeOptions: JSON.parse(customTheme.innerText) ?? {},
    errors: JSON.parse(loginErrors),
	singleSignOnEnabled: {
		microsoft: ssoEnabledMicrosoft,
		google: ssoEnabledGoogle,
	},
});
